import { render, staticRenderFns } from "./ConcessionsList.vue?vue&type=template&id=0c7a76b1&"
import script from "./ConcessionsList.vue?vue&type=script&lang=js&"
export * from "./ConcessionsList.vue?vue&type=script&lang=js&"
import style0 from "./ConcessionsList.vue?vue&type=style&index=0&id=0c7a76b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports